import React, { createContext, useContext, useState, useRef, useCallback } from 'react';
import { useAuth } from './auth';
import api from '../api';

var PlayCountsContext = createContext();

function PlayCountsProvider(props) {
  var auth = useAuth();
  var isAdmin = auth.authTokens?.user?.isAdmin;
  var _counts = useState({});
  var counts = _counts[0];
  var setCounts = _counts[1];
  var pendingRef = useRef([]);
  var timerRef = useRef(null);

  var register = useCallback(
    function (postId) {
      if (!isAdmin || !postId) return;
      pendingRef.current.push(postId);

      if (timerRef.current) return;
      timerRef.current = setTimeout(function () {
        var ids = Array.from(new Set(pendingRef.current));
        pendingRef.current = [];
        timerRef.current = null;
        if (ids.length === 0) return;

        api
          .post('/api/admin/play-counts', { postIds: ids })
          .then(function (res) {
            var data = res.data;
            if (data && data.counts) {
              setCounts(function (prev) {
                var next = Object.assign({}, prev);
                data.counts.forEach(function (c) {
                  next[c.postId] = {
                    fullPlays: c.fullPlays,
                    previewPlays: c.previewPlays,
                    serviceOpens: c.serviceOpens,
                  };
                });
                // Mark posts with zero counts so we don't re-fetch
                ids.forEach(function (id) {
                  if (!next[id]) {
                    next[id] = { fullPlays: 0, previewPlays: 0, serviceOpens: 0 };
                  }
                });
                return next;
              });
            }
          })
          .catch(function () {});
      }, 100);
    },
    [isAdmin]
  );

  var value = { counts: counts, register: register, isAdmin: isAdmin };

  return React.createElement(PlayCountsContext.Provider, { value: value }, props.children);
}

function usePlayCounts() {
  return useContext(PlayCountsContext) || { counts: {}, register: function () {}, isAdmin: false };
}

export { PlayCountsProvider, usePlayCounts };
